// Area mapping
// No two can have same stallId
//

import { HALL_KEYS_CONSTANT_DATA } from "./AreaOptionData";

const Hall_Jio_layoutData =[
  {
    "stallId": "StallJIO-A_1a",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-A_1b",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-A_1c",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-A_1d",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-A_1e",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-A_1f",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-A_1g",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-A_1h",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-B_1i",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-B_1j",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-B_1k",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-B_1l",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-B_1m",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-B_1n",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-B_1p",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-B_1q",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-B_4a",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-B_4b",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-B_4c",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-B_4d",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-B_4e",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-B_4f",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-B_4g",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-B_4h",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-B_4i",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-C_4j",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-C_4k",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-C_4l",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-C_4m",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-C_4n",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-C_4p",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-C_4q",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-C_4r",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-C_4s",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-C_5a",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-C_5b",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-C_5c",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-C_5d",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-C_5e",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-C_5f",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-C_5g",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P3",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-C_6a",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-C_6b",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-C_6c",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-C_6d",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-C_6e",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-C_6f",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-C_6g",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-C_6h",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-D_5h",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-D_5i",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-D_5j",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-D_5k",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-D_5l",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-D_5m",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-D_5n",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-D_5p",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-D_6i",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-D_6j",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-D_6k",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-D_6l",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-D_6m",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-D_6n",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-D_6p",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-D_6q",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-D_6r",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-D_7a",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-D_7b",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-D_7c",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-D_7d",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-D_7e",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-D_7f",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-D_7g",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-D_7h",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-D_8a",
    "area": 36,
    "hallId": "Pavillion",
    "section": "sectionData_4",
    "zone": "P1",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-D_8b",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_4",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-D_8c",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_4",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-D_8d",
    "area": 27,
    "hallId": "Pavillion",
    "section": "sectionData_4",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-D_8e",
    "area": 36,
    "hallId": "Pavillion",
    "section": "sectionData_4",
    "zone": "P1",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-E_8f",
    "area": 27,
    "hallId": "Pavillion",
    "section": "sectionData_4",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-E_8g",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_4",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-E_8h",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_4",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-E_10a",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-E_10b",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-E_10c",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-E_10d",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-E_10e",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-E_10f",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-E_7i",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-E_7j",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-E_7k",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-E_7l",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-E_7m",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-E_7n",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-E_7p",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-E_7q",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-E_9a",
    "area": 36,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P1",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-E_9b",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-E_9c",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-E_9d",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-E_9e",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-E_9f",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-E_9g",
    "area": 36,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P1",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-F_10g",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-F_10h",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-F_10i",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-F_10j",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-F_10k",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-F_10l",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-F_11a",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-F_11b",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-F_11c",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-F_11d",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-F_11e",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-F_11f",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-F_11g",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-F_11h",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-F_12a",
    "area": 72,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P1",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X12",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-F_12b",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-F_12c",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-F_12d",
    "area": 36,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P1",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-F_9h",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-F_9i",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-F_9j",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-F_9k",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-F_9l",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-G_11i",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-G_11j",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-G_11k",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-G_11l",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-G_11m",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-G_11n",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-G_11p",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-G_11q",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-G_12e",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-G_12f",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-G_13a",
    "area": 36,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-G_13b",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-G_13c",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-G_13d",
    "area": 36,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-G_14a",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-G_14b",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-G_14c",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-G_14d",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-G_14e",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-G_14f",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-G_14g",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-G_14h",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-H_13e",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-H_13f",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-H_13g",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-H_14i",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-H_14j",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-H_14k",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-H_14l",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-H_14m",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-H_14n",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-H_14p",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-H_14q",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-H_14r",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-H_15a",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-H_15b",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-H_15c",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-H_15d",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-H_15e",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-H_15f",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-H_15g",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-H_15h",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-H_15i",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-H_16a",
    "area": 27,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-H_16b",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-H_16c",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-H_16d",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-H_16e",
    "area": 36,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-J_15j",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-J_15k",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-J_15l",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-J_15m",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-J_15n",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-J_15p",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-J_15q",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-J_15r",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-J_16f",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-J_16g",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-J_16h",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-J_16i",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-J_16j",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-J_17a",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-J_17b",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-J_17c",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-J_17d",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-J_17e",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-J_17f",
    "area": 36,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x6",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-J_18a",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-J_18b",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-J_18c",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-J_18d",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-J_18e",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-J_18f",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-J_18g",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-J_18h",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-K_17g",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-K_17h",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-K_17i",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-K_17j",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-K_17k",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-K_18i",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-K_18j",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-K_18k",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-K_18l",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-K_18m",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-K_18n",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-K_18p",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-K_18q",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-K_19a",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-K_19b",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-K_19c",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-K_19d",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-K_19e",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-K_19f",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-K_19g",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-K_19h",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-K_20a",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-K_20b",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-K_20c",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-K_20d",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-K_20e",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-K_20f",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-K_20g",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-L_19i",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-L_19j",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-L_19k",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-L_19l",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-L_19m",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-L_19n",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-L_19p",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-L_19q",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-L_20h",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-L_20i",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-L_20j",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-L_20k",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-L_20l",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-L_20m",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-L_20n",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-L_21a",
    "area": 36,
    "hallId": "Pavillion",
    "section": "sectionData_7",
    "zone": "P2",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-L_21b",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-L_21d",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-L_21e",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-L_22a",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-L_22b",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-L_22c",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-L_22d",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-L_22e",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-L_22f",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-L_22g",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-M_21f",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-M_21g",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-M_21h",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-M_21i",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-M_21j",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_10",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-M_21k",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_7",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-M_22h",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-M_22i",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-M_22j",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-M_22k",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-M_22l",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-M_22m",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-M_22n",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-M_22p",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-M_23a",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-M_23b",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-M_23c",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-M_23d",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-M_23e",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-M_23f",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-M_23g",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-M_24a",
    "area": 36,
    "hallId": "Pavillion",
    "section": "sectionData_7",
    "zone": "P2",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-M_24b",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_7",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-M_24c",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_7",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-M_24ab",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_7",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-N_23h",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-N_23i",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-N_23j",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-N_23k",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-N_23l",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-N_23m",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-N_23n",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P2",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-N_24d",
    "area": 27,
    "hallId": "Pavillion",
    "section": "sectionData_7",
    "zone": "P2",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-N_25a",
    "area": 108,
    "hallId": "Pavillion",
    "section": "sectionData_7",
    "zone": "P3",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X18",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-N_25b",
    "area": 36,
    "hallId": "Pavillion",
    "section": "sectionData_7",
    "zone": "P3",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-N_26a",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P3",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-N_26b",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-N_26c",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-N_26d",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-N_26e",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-N_26f",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-N_26g",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P3",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-P_26h",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-P_26i",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-P_26j",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-P_26k",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-P_26l",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-P_26m",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-P_26n",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P3",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-P_27a",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P3",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-P_27b",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-P_27c",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-P_27d",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-P_27e",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-P_27f",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-P_27g",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P3",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-P_28a",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_7",
    "zone": "P3",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Q_28l",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_7",
    "zone": "P3",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-P_28b",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_7",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-P_28c",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_7",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-P_28d",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_7",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-P_28e",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_7",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-P_28f",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_7",
    "zone": "P3",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Q_27h",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P3",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Q_27i",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Q_27j",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Q_27k",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Q_27l",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_2",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Q_27m",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Q_27n",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Q_27p",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Q_27q",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Q_28g",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_7",
    "zone": "P3",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Q_28h",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_7",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Q_28i",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_7",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Q_28j",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_7",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Q_28k",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_7",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Q_29a",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Q_29b",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Q_29c",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Q_29d",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Q_30a",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Q_30b",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Q_30c",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Q_30d",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Q_30e",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Q_30f",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Q_30g",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Q_30h",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-R_29e",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-R_29f",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-R_29g",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-R_29h",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-R_29i",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-R_30i",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-R_30j",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-R_30k",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-R_30l",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-R_30m",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-R_30n",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-R_30p",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-R_30q",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-R_30r",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-R_31a",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-R_31b",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-R_31c",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-R_31d",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-R_31e",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-R_31f",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-R_31g",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-R_31h",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-R_32a",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-R_32b",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-R_32c",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-R_32d",
    "area": 27,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-S_31i",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-S_31j",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-S_31k",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-S_31l",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-S_31m",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-S_31n",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-S_31p",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-S_31q",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-S_32e",
    "area": 27,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-S_32f",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-S_32g",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-S_32h",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-S_33a",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-S_33b",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-S_33c",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-S_33d",
    "area": 27,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-S_34a",
    "area": 27,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-S_34b",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-S_34c",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-S_34d",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-S_34e",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-S_34f",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-S_34g",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-T_33e",
    "area": 27,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-T_33f",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-T_33g",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-T_33h",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-T_34h",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-T_34i",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-T_34j",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-T_34k",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-T_34l",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-T_34m",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-T_34n",
    "area": 27,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-T_35a",
    "area": 54,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-T_35b",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-T_35c",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-T_35d",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-T_35e",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-T_35f",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-T_35g",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-T_36a",
    "area": 36,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-T_36b",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-T_36c",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-T_36d",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-T_36e",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-T_36f",
    "area": 36,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-U_35h",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-U_35i",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-U_35j",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-U_35k",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-U_35l",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-U_35m",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-U_36g",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-U_36h",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-U_36i",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-U_36j",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P3",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-U_37a",
    "area": 36,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-U_37b",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-U_37c",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-U_37d",
    "area": 36,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-U_38a",
    "area": 54,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-U_38b",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-U_38c",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-U_38d",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-U_38e",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-U_38f",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-V_37e",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-V_37f",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-V_37g",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-V_37h",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-V_38g",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-V_38h",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-V_38i",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-V_38j",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-V_38k",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-V_38l",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-V_39a",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-V_39b",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-V_39c",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-V_39d",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-V_39e",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-V_39f",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-V_39g",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-V_40a",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-V_40b",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-V_40c",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-V_40d",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-V_40e",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-W_39h",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-W_39i",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-W_39j",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-W_39k",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-W_39l",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-W_39m",
    "area": 12,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-W_39n",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-W_40f",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-W_40g",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-W_40h",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-W_40i",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-W_40j",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-W_41a",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-W_41b",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-W_41c",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-W_41d",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-W_42a",
    "area": 36,
    "hallId": "Pavillion",
    "section": "sectionData_6",
    "zone": "P4",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-W_42b",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-W_42c",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-W_42d",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-W_42e",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-W_42f",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-W_42g",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-W_42h",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-X_41e",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-X_41f",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-X_41g",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-X_41h",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-X_42i",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-X_42j",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-X_42k",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-X_42l",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-X_42m",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-X_42n",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-X_42p",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_6",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-X_43a",
    "area": 54,
    "hallId": "Pavillion",
    "section": "sectionData_6",
    "zone": "P4",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-X_43b",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_6",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-X_43c",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_6",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-X_43d",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_6",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-X_43e",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_6",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-X_43f",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_6",
    "zone": "P4",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-X_44a",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-X_44b",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-X_44c",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-X_44d",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-X_44e",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-X_44f",
    "area": 36,
    "hallId": "Pavillion",
    "section": "sectionData_5",
    "zone": "P4",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Y_43g",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_6",
    "zone": "P4",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Y_43h",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_6",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Y_43i",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_6",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Y_43j",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_6",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Y_44g",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_5",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Y_44h",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Y_44i",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Y_44j",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Y_44k",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_3",
    "zone": "P4",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Y_45a",
    "area": 36,
    "hallId": "Pavillion",
    "section": "sectionData_5",
    "zone": "P4",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Y_45b",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_5",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Y_45c",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_5",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Y_45d",
    "area": 36,
    "hallId": "Pavillion",
    "section": "sectionData_5",
    "zone": "P4",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Y_46a",
    "area": 54,
    "hallId": "Pavillion",
    "section": "sectionData_6",
    "zone": "P4",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Y_46b",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_6",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Y_46c",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_6",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Y_46d",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_6",
    "zone": "P4",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Z_45e",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_5",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Z_45f",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_5",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Z_45g",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_5",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Z_45h",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_5",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Z_46e",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_6",
    "zone": "P4",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Z_46f",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_6",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Z_46g",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_6",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Z_46h",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_6",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Z_47a",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_6",
    "zone": "P4",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Z_47b",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_6",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Z_47c",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_6",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Z_47d",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_6",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Z_47e",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_6",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Z_47f",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_6",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Z_47g",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_6",
    "zone": "P4",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Z_48a",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_5",
    "zone": "P4",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Z_48b",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_5",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Z_48c",
    "area": 9,
    "hallId": "Pavillion",
    "section": "sectionData_5",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Z_48d",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_5",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Z_48e",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_5",
    "zone": "P4",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  },
  {
    "stallId": "StallJIO-Z_48f",
    "area": 18,
    "hallId": "Pavillion",
    "section": "sectionData_5",
    "zone": "P4",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "JWCC",
    "serviceProvider": "vendor1"
  }
]

export const HallLayoutData = {
  [HALL_KEYS_CONSTANT_DATA.Pavillion]: Hall_Jio_layoutData,
  // [HALL_KEYS_CONSTANT_DATA.h1]: Hall1_layoutData,
  // [HALL_KEYS_CONSTANT_DATA.h2]: Hall2_layoutData,
  // [HALL_KEYS_CONSTANT_DATA.h3]: Hall3_layoutData,
  // [HALL_KEYS_CONSTANT_DATA.h4]: Hall4_layoutData,
  // [HALL_KEYS_CONSTANT_DATA.h5]: Hall5_layoutData,
  // [HALL_KEYS_CONSTANT_DATA.h6]:  Hall6_layoutData,
  // [HALL_KEYS_CONSTANT_DATA.h7]: Hall7_layoutData,
};

export const LAYOUT_VENU = "Pavillion";
